import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function MobileCtaBar() {
  const { pathname } = useLocation();
  if (pathname === "/contact" || pathname === "/book") return null;
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-[60] bg-charcoal/92 backdrop-blur-md border-t rule-dark px-4 pt-3"
      style={{ paddingBottom: "max(12px, env(safe-area-inset-bottom))" }}
      data-testid="mobile-cta-bar"
    >
      <Link to="/contact" className="btn-gold w-full justify-center" data-testid="mobile-sticky-consultation-button">
        Book an ESG & Sustainability Consultation <ArrowUpRight size={15} />
      </Link>
    </div>
  );
}
